// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-container {
  width: 100%;
  height: calc(100vh - 195px); /* Adjust height to account for navbar */
  padding: 0;
  margin: 0;
  margin-top: 195px; /* Keep the margin to position below navbar */
  overflow: hidden;
  position: relative;
}

.chat-iframe {
  width: 100%;
  height: 100%;
  border: none;
  overflow: hidden;
  background: #fff;
}

/* Override default page styling for chat */
.pagina {
  height: 100vh;
  overflow: hidden;
}

.pagina .contenido-principal {
  padding: 0;
  margin: 0;
  height: 100vh; /* Use full viewport height */
  overflow: hidden;
}

/* Remove any default margins/padding that might interfere */
.pagina.chat-page {
  margin: 0;
  padding: 0;
}

.pagina.chat-page .contenido-principal {
  margin: 0;
  padding: 0;
} `, "",{"version":3,"sources":["webpack://./src/pages/css/Chat.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,2BAA2B,EAAE,wCAAwC;EACrE,UAAU;EACV,SAAS;EACT,iBAAiB,EAAE,6CAA6C;EAChE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,aAAa,EAAE,6BAA6B;EAC5C,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;AACZ","sourcesContent":[".chat-container {\n  width: 100%;\n  height: calc(100vh - 195px); /* Adjust height to account for navbar */\n  padding: 0;\n  margin: 0;\n  margin-top: 195px; /* Keep the margin to position below navbar */\n  overflow: hidden;\n  position: relative;\n}\n\n.chat-iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n  overflow: hidden;\n  background: #fff;\n}\n\n/* Override default page styling for chat */\n.pagina {\n  height: 100vh;\n  overflow: hidden;\n}\n\n.pagina .contenido-principal {\n  padding: 0;\n  margin: 0;\n  height: 100vh; /* Use full viewport height */\n  overflow: hidden;\n}\n\n/* Remove any default margins/padding that might interfere */\n.pagina.chat-page {\n  margin: 0;\n  padding: 0;\n}\n\n.pagina.chat-page .contenido-principal {\n  margin: 0;\n  padding: 0;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
